const Fields = [
  { label: "Payment Type", name: "newPaymentTypeId", select: true },
  // {
  //   label: "Note",
  //   name: "notes",
  //   select: true,
  // },
  // {
  //   label: "Comp Account",
  //   name: "compAccountId",
  //   select: true,
  // },
  // {
  //   label: "Employee",
  //   name: "employeeId",
  //   select: true,
  // },
  // {
  //   label: "Amount",
  //   name: "amount",
  //   type: "number",
  // },
  // {
  //   label: "Discount",
  //   name: "discount",
  //   type: "number",
  // },
];

export default Fields;
